import customAxios from '../../customAxios';

import { ADMIN_FIND_WITHDRAWAL_COMPANIES } from '../../routes';
import { WithdrawalCompanyNamespace      } from '../../../types/withdrawalCompany.namespace';

async function findWithdrawalCompanies(props: WithdrawalCompanyNamespace.interfaceFindWithdrawalCompany) {
  try {
    return (await customAxios.post(ADMIN_FIND_WITHDRAWAL_COMPANIES, props)).data;
  } catch (error: any) {
    console.error({FIND_TRANSACTION: error});
  }
}

export default findWithdrawalCompanies;
